module.exports = __webpack_public_path__ + "img/196.0131fe39.jpg";